export default '/build/f73aeec6.jpg'